import { render, staticRenderFns } from "./GeneralEmptyApply.vue?vue&type=template&id=63860af6"
import script from "./GeneralEmptyApply.vue?vue&type=script&lang=ts"
export * from "./GeneralEmptyApply.vue?vue&type=script&lang=ts"
import style0 from "./GeneralEmptyApply.vue?vue&type=style&index=0&id=63860af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports